<template>
  <div class="fromStyle">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目" prop="project_id">
        <h3>{{ details.project_name }}</h3>
      </a-form-model-item>
      <!-- 员工模版--结算 -->
      <a-form-model-item label="员工配置">
        <a-radio-group v-model="form.independent" @change="selectedIndependent">
          <a-radio :value="1" :disabled="independentTrue">自定义配置</a-radio>
          <a-radio :value="2" :disabled="independentFalse">默认配置</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="计薪方式" prop="compute">
        <a-checkbox-group @change="selectedType" v-model="form.compute">
          <a-checkbox :value="1" name="compute"> 单价 </a-checkbox>
          <a-checkbox :value="2" name="compute"> 时薪 </a-checkbox>
          <a-checkbox :value="3" name="compute"> 底薪 </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="计算金额" v-show="form.compute != ''">
        <ul class="subList">
          <li v-show="form.compute != undefined && form.compute.includes(1)">
            <label><i>*</i>单价&nbsp;</label>
            <a-input-number
              v-model="form.guard_price"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
          <li v-show="form.compute != undefined && form.compute.includes(2)">
            <label><i>*</i>每小时&nbsp;</label>
            <a-input-number
              v-model="form.guard_time_price"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
          <li v-show="form.compute != undefined && form.compute.includes(3)">
            <label><i>*</i>底薪&nbsp;</label>
            <a-input-number
              v-model="form.guard_base_salary"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
        </ul>
      </a-form-model-item>
      <a-form-model-item label="默认每日计算参数" v-show="form.compute != ''">
        <ul class="subList">
          <li v-show="form.compute != undefined && form.compute.includes(1)">
            <label><i>*</i>单量&nbsp;</label>
            <a-input-number
              v-model="form.default_order"
              style="margin-right: 10px"
              :min="0"
            />
            <span>单</span>
          </li>
          <li v-show="form.compute != undefined && form.compute.includes(2)">
            <label><i>*</i>工时&nbsp;</label>
            <a-input-number
              v-model="form.default_hour"
              style="margin-right: 10px"
              :min="0"
            />
            <span>小时</span>
          </li>
          <li v-show="form.compute != undefined && form.compute.includes(3)">
            <label><i>*</i>日薪&nbsp;</label>
            <a-input-number
              v-model="form.default_day"
              style="margin-right: 10px"
              :min="0"
            />
            <span>元</span>
          </li>
        </ul>
      </a-form-model-item>
      <!-- 甲方模版--结算 -->
      <a-form-model-item label="甲方模版--结算" prop="ownerSettle">
        <a-checkbox-group v-model="form.ownerSettle">
          <a-checkbox :value="1" name="compute"> 服务费 </a-checkbox>
          <a-checkbox :value="2" name="compute"> 单价 </a-checkbox>
          <a-checkbox :value="3" name="compute"> 时薪 </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item
        label="满勤天数"
        v-if="
          form.ownerSettle != undefined ? form.ownerSettle.includes(1) : false
        "
        prop="full_day"
      >
        <a-input-number v-model="form.full_day" />
        <span>&nbsp;天</span>
      </a-form-model-item>
      <a-form-model-item
        label="最低出勤天数"
        v-if="
          form.ownerSettle != undefined ? form.ownerSettle.includes(1) : false
        "
        prop="min_day"
      >
        <a-input-number v-model="form.min_day" />
        <span>&nbsp;天</span>
      </a-form-model-item>
      <a-form-model-item
        label="服务费"
        v-if="
          form.ownerSettle != undefined ? form.ownerSettle.includes(1) : false
        "
        prop="head_fee"
      >
        <a-input-number v-model="form.head_fee" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item
        label="单价"
        prop="three_price"
        v-if="
          form.ownerSettle != undefined ? form.ownerSettle.includes(2) : false
        "
      >
        <a-input-number
          v-model="form.three_price"
          style="margin-right: 10px"
          :min="0"
        />
        <span>元</span>
      </a-form-model-item>
      <a-form-model-item
        label="每小时"
        prop="three_time_price"
        v-if="
          form.ownerSettle != undefined ? form.ownerSettle.includes(3) : false
        "
      >
        <a-input-number
          v-model="form.three_time_price"
          style="margin-right: 10px"
          :min="0"
        />
        <span>元</span>
      </a-form-model-item>
      <!-- 甲方模版--结算 end -->
      <a-form-model-item
        style="margin-top: 50px"
        :wrapper-col="{ span: 12, offset: 6 }"
      >
        <a-button @click="resetForm">重置</a-button>
        <a-button style="margin-left: 10px" type="primary" @click="handleSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      form: {
        workerOrder: 1,
        workerSettle: 1,
        ownerSettle: [],
        compute: [],
        independent: "",
        guard_price: "",
        guard_time_price: "",
        guard_base_salary: "",
        three_price: "",
        three_time_price: "",
        head_fee: "",
        min_day: "",
        full_day: "",
        default_order: "",
        default_hour: "",
        default_day: ""
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      rules: {
        default_order: [
          {
            required: true,
            message: "请输入单量",
            trigger: "blur"
          }
        ],
        default_hour: [
          {
            required: true,
            message: "请输入时薪",
            trigger: "blur"
          }
        ],
        default_day: [
          {
            required: true,
            message: "请输入底薪",
            trigger: "blur"
          }
        ],
        compute: [
          {
            required: true,
            message: "请选择计薪方式",
            trigger: "change"
          }
        ],
        full_day: [
          {
            required: true,
            message: "请填写满勤天数",
            trigger: "blur"
          }
        ],
        min_day: [
          {
            required: true,
            message: "请填写最低出勤天数",
            trigger: "blur"
          }
        ],
        head_fee: [
          {
            required: true,
            message: "请填写服务费",
            trigger: "blur"
          }
        ],
        three_price: [
          {
            required: true,
            message: "请填写甲方单价",
            trigger: "blur"
          }
        ],
        three_time_price: [
          {
            required: true,
            message: "请填写甲方时薪",
            trigger: "blur"
          }
        ]
      },
      ownerSettle: [
        {
          required: true,
          message: "请选择甲方结算方式",
          trigger: "change"
        }
      ],
      proList: [],
      independentTrue: false,
      independentFalse: false,
      roleList: [],
      details: {}
    };
  },
  mounted() {
    this.getPro(); //获取客户列表
    if (this.editDetail != undefined) {
      this.getDetails();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.editDetail;
      this.form = {
        independent: this.details.guard_single_config,
        compute: this.details.guard_count_type,
        guard_price: this.details.guard_price,
        guard_time_price: this.details.guard_time_price,
        guard_base_salary: this.details.guard_base_salary,
        ownerSettle: this.details.three_count_type,
        three_price: this.details.three_price,
        three_time_price: this.details.three_time_price,
        full_day: this.details.full_day,
        min_day: this.details.min_day,
        head_fee: this.details.head_fee,
        default_order: this.details.default_order,
        default_hour: this.details.default_hour,
        default_day: this.details.default_day
      };
      //   console.log(this.details);
    },
    selectProID() {
      this.getRole();
    },
    selectedIndependent() {
      if (this.form.compute != "") {
        if (this.form.compute.length != 1) {
          this.independentFalse = true;
        } else {
          this.independentFalse = false;
        }
      } else {
        this.independentFalse = false;
      }
    },
    selectedType(val) {
      // console.log(this.form.type.length == 1 && this.form.compute.length == 1)
      if (this.form.compute != "") {
        if (this.form.compute.length == 1) {
          this.form.independent = 2;
          this.independentFalse = false;
        } else {
          this.form.independent = 1;
          this.independentFalse = true;
        }
      } else {
        this.form.independent = "";
        this.independentFalse = false;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          trade_id: 5,
          is_config: 1,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    verify() {
      let fls = true;
      if (this.form.compute.includes(1) && this.form.guard_price == "") {
        fls = false;
        this.$message.warning("请填写单价！");
        return fls;
      }
      if (this.form.compute.includes(2) && this.form.guard_time_price == "") {
        fls = false;
        this.$message.warning("请填写时薪！");
        return fls;
      }
      if (this.form.compute.includes(3) && this.form.guard_base_salary == "") {
        fls = false;
        this.$message.warning("请填写底薪！");
        return fls;
      }
      return fls;
    },
    resetForm() {
      this.form.guard_price == "";
      this.form.guard_time_price == "";
      this.form.guard_base_salary == "";
      this.$refs.ruleForm.resetFields();
    },
    handleSubmit(e) {
      e.preventDefault();
      let fls = this.verify();
      //   console.log(attr_config);
      this.$refs.ruleForm.validate(valid => {
        // console.log(this.form);
        if (valid) {
          if (fls) {
            let url =
              this.httpsBasic.url +
              this.httpsBasic.people +
              "Account_config/editAccountConfig";
            let params = {
              id: this.details.id,
              guard_single_config: this.form.independent,
              guard_count_type: JSON.stringify(this.form.compute),
              guard_price: this.form.guard_price,
              guard_time_price: this.form.guard_time_price,
              guard_base_salary: this.form.guard_base_salary,
              three_count_type: JSON.stringify(this.form.ownerSettle),
              three_price: this.form.three_price,
              three_time_price: this.form.three_time_price,
              full_day: this.form.full_day,
              min_day: this.form.min_day,
              head_fee: this.form.head_fee,
              token: window.localStorage.getItem("xnwfPcToken"),
              default_order: this.form.default_order,
              default_hour: this.form.default_hour,
              default_day: this.form.default_day
            };
            // console.log(params);
            axios.post(url, params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.resetForm();
                this.$emit("hideInEdit", true);
              } else {
                this.$emit("hideInEdit", false);
                this.$message.warning(res.data.message);
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fromStyle {
  padding-bottom: 30px;
  padding-top: 50px;
}
.subList {
  li {
    // margin-bottom: 10px;
    display: inline-block;
    margin-right: 30px;
    i {
      font-size: 14px;
      color: #f56c6c;
      font-style: normal;
      display: inline-block;
      margin-right: 4px;
    }
  }
}
</style>
